import toLower from 'lodash/toLower';
import { startCase } from '@fff-web/fff-utilities';

export const titleCase = (str) => startCase(toLower(str));
